import type { CmpHider } from './types';

export const cookieyes: CmpHider = {
  id: 'cookieyes',
  label: 'CookieYes',
  css: `
      /* CookieYes (cookieyes.com CMP): two generations ship distinct markup.
         Current "cky-" builds render a fixed consent bar (.cky-consent-container
         / .cky-consent-bar), a centered preferences modal (.cky-modal /
         .cky-preference-center), a separate fixed full-screen dimming backdrop
         (.cky-overlay), and a persistent fixed floating "revisit/cog" button
         (.cky-btn-revisit-wrapper) that stays after consent — hide all of them.
         Legacy "cli-/cookie-law-info" builds render the bottom bar in
         #cookie-law-info-bar, the preferences popup in #cliSettingsPopup, and a
         fixed dimming backdrop in .cli-modal-backdrop / #cliModalBackdrop — hide
         those too. CookieYes locks page scroll by adding the
         "cli-barmodal-open" class to <body> (legacy) or via an inline
         "overflow: hidden" on <body> (current); we release the class lock by
         leading with "html body" to out-specify CookieYes's own rule, and the
         html/html-body[style*="overflow"] release rule above (added for
         Cookiebot) already out-specifies the inline lock. */
      .cky-consent-container,
      .cky-consent-bar,
      .cky-modal,
      .cky-overlay,
      .cky-btn-revisit-wrapper,
      #cookie-law-info-bar,
      #cliSettingsPopup,
      .cli-modal-backdrop,
      #cliModalBackdrop { display: none !important; }
      html body.cli-barmodal-open {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
